import React, { FC, useContext } from 'react';

import { RELATIONSHIP_TYPES } from '../../../../constants/common/relationShipTypes';
import { TXN_REASON } from '../../../../constants/enrollmentList/enrollmentList.constant';
import { INPUT_TYPES } from '../../../../constants/inputs/inputTypes';
import Dropdown from '../../../../lib/inputs/Dropdown';
import { changeFieldValue, getOptionsByTxnType } from '../common/enrollmentUtils';
import { IEnrollee } from '../common/types';
import { AddOrChangeTxnFormContext } from '../context/AddOrChangeTxnProvider';

interface IEnrollmentTxnTypeReasonProps {
    enrollee: IEnrollee;
}

const EnrollmentTxnTypeReason: FC<IEnrollmentTxnTypeReasonProps> = ({ enrollee }) => {
    const { setValue, watch } = useContext(AddOrChangeTxnFormContext);
    const values = watch();

    const handleChange = value => {
        changeFieldValue(setValue, `enrolleeDataDtoList.${enrollee.index}.txnReason`, value);
        changeFieldValue(setValue, `enrollmentLastPremPaidThroughDateUI`, '');

        changeFieldValue(setValue, `isTermReasonNonPayment`, false);
        values.enrolleeDataDtoList.forEach(function (enrollee) {
            if (
                enrollee.relationshipToSubscriber.toUpperCase() === RELATIONSHIP_TYPES.SELF.value &&
                enrollee.txnReason === TXN_REASON.FiftyNine
            ) {
                changeFieldValue(setValue, `isTermReasonNonPayment`, true);
                changeFieldValue(setValue, `addOrChangeSendIn834`, false);
                changeFieldValue(setValue, `sendTermNoticeVM`, false);
            }
        });
    };

    return (
        <Dropdown
            label={{
                text: '',
                labelClass: [''],
            }}
            inputData={{
                inputClasses: [''],
                options: getOptionsByTxnType(enrollee.txnType, enrollee.relationshipToSubscriber),
                type: INPUT_TYPES.DROPDOWN,
                value: enrollee.txnReason,
                isInputRequired: false,
            }}
            inputActions={{
                handleFieldChange: handleChange,
            }}
        />
    );
};

export default EnrollmentTxnTypeReason;
